//export enum SituacaoEnum {
export class SituacaoEnum {
  public static NaoConcluido={id:1, descricao:"Não Concluído"};
  public static EmAnalise={id:2, descricao:"Em Análise"};

  public static getCombo(){
    let  combo =  [
      { id: null,
        denominacao: "-Selecione-"
      },
      {
        id: SituacaoEnum.NaoConcluido.id,
        denominacao: SituacaoEnum.NaoConcluido.descricao
      },
      {
        id: SituacaoEnum.EmAnalise.id,
        denominacao: SituacaoEnum.EmAnalise.descricao
      }
    ];

    return combo;
  }

}
